import { render, staticRenderFns } from "./PanelProductCrudTable.vue?vue&type=template&id=bab1bcca&scoped=true"
import script from "./PanelProductCrudTable.vue?vue&type=script&lang=js"
export * from "./PanelProductCrudTable.vue?vue&type=script&lang=js"
import style0 from "./PanelProductCrudTable.vue?vue&type=style&index=0&id=bab1bcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1bcca",
  null
  
)

export default component.exports